module.exports = __webpack_public_path__ + "img/mockinterview-heading.9788d13d.svg";